// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  min-height: 0;
  max-height: 100%;
  color: var(--color-content-base);
  font-weight: 400;
  font-size: 16px;
  font-family: 'IBM Plex Sans';
  background-color: var(--color-background-layer-1);
  box-shadow: 0 2px 7px 1px var(--color-shadow-base);
  border-radius: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}
.table--withBorderRadius {
  border-radius: 8px;
}
.table--virtualized thead,
.table--virtualized tbody {
  display: grid;
}
.table:not(.table--virtualized) {
  table-layout: fixed;
}
.table:not(.table--virtualized) tbody {
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/table/Table.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EAEA,aAAA;EACA,gBAAA;EAEA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,iDAAA;EACA,kDAAA;EACA,gBAAA;EAMA,aAAA;EACA,uCAAA;AAEF;AAPE;EACE,kBAAA;AASJ;AAHE;;EAGI,aAAA;AAIN;AAAE;EACE,mBAAA;AAEJ;AAHE;EAII,aAAA;EACA,gBAAA;EACA,kBAAA;AAEN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n\n  min-height: 0;\n  max-height: 100%;\n\n  color: var(--color-content-base);\n  font-weight: @fontWeight-normal;\n  font-size: @fontSize-base;\n  font-family: @IBMPlexSans;\n  background-color: var(--color-background-layer-1);\n  box-shadow: @box-shadow;\n  border-radius: 0;\n\n  &--withBorderRadius {\n    border-radius: @layoutUnit-sm;\n  }\n\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr);\n\n  &--virtualized {\n    thead,\n    tbody {\n      display: grid;\n    }\n  }\n\n  &:not(.table--virtualized) {\n    table-layout: fixed;\n\n    tbody {\n      min-height: 0;\n      overflow-y: auto;\n      overflow-x: hidden;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
